import Route from '@ember/routing/route';

import '../css/not-found.css';

export default class NotFoundRoute extends Route {}
